export default __webpack_public_path__ + "static/media/escmgr-hover.f60f66b2.svg";